import React, { useEffect, useState } from "react";
import apiRequest from "../../../utils/ApiRequest/apiRequest.js";
import config from "config";
import LoadingImageElement from "components/Elements/LoadingContainerElement/LoadingImageElement.tsx";
import { useParams } from "react-router";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useModal } from "../../../contexts/modalContext/modalContext.js";
import { sleep } from "./Helpers/sleep.js";

const sleepEvents = () => {
  const data =
    "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";

  const video = document.createElement("video");
  video.loop = true;
  video.muted = true;
  video.src = `data:video/mp4;base64,${data}`;

  video.play().then(
    () => {
      Object.entries({
        pause: "sleep",
        play: "wake",
      }).forEach(([type, customType]) => {
        video.addEventListener(type, () => {
          document.dispatchEvent(
            new CustomEvent(customType, { detail: Date.now() })
          );
        });
      });
      console.info("System sleep/wake detection video initialized.");
    },
    () => {
      console.error("Unable to initialize system sleep/wake detection.");
    }
  );
};

export const UploaderLogicComponent = ({
  children,
  setToken,
  setIsJMPay,
  embedMailId = null,
  setEmbedFormDetails,
}) => {
  const { setModal } = useModal();
  const { getPath } = useContent();
  const { mailId } = useParams();
  const encryptMailId = embedMailId ? embedMailId : mailId;
  const [status, setStatus] = useState(null);
  const [showUploader, setShowUploader] = useState(false);
  const [loading, setLoading] = useState(false);

  const checkUserAllowUploadMore = async (callback) => {
    const response = await apiRequest("", "", {}, "");
    if (response.status === "success") {
      if (response.data) {
        callback(true);
      }
    }
  };

  const getEmbedDynamicEncrtptedMailId = async () => {
    const res = await apiRequest(
      "EmbedDynamics",
      "ReactGetEmbedDynamicFormByEncryptedMailID",
      {
        encryptedMailId: encryptMailId,
      }
    );

    if (res.status === "success") {
      if (res.data) {
        setEmbedFormDetails(res.data);
      }
    }
  };

  const handleGetStatus = async () => {
    setLoading(true);
    const response = await apiRequest("Mails", "ReactGetUploadInfo", {
      encryptedMailId: encryptMailId,
    });
    if (response.status === "success") {
      setStatus(response.data.status);
      setToken(response.data.csrf);
      setIsJMPay(response.data.isJumboPay);
    } else {
      window.location.href = config.baseurl + getPath() + "error";
    }
    setLoading(false);
  };

  // fetch mailInfo and status based on mailId
  useEffect(() => {
    if (encryptMailId) {
      handleGetStatus();
      if (embedMailId) {
        getEmbedDynamicEncrtptedMailId();
      }
    }
  }, [encryptMailId]);

  // check mailStatus
  useEffect(() => {
    if (status && !loading) {
      if (status === "CREATED" || process.env.REACT_APP_STAGE === "dev ") {
        setShowUploader(true);
      } else if (["sent", "upload_error"].includes(status)) {
        window.location.href =
          config.baseurl + getPath() + "error/mailkeyexist";
        // checkUserAllowUploadMore(setShowUploader);
      } else {
        //redirect to mailKeyExist
        window.location.href =
          config.baseurl + getPath() + "error/mailkeyexist";
      }
    }
  }, [status, loading]);

  useEffect(() => {
    sleep.prevent();
    return () => {
      sleep.allow();
    };
  }, []);

  return (
    <div className="uplodaer-container">
      {showUploader ? children : <LoadingImageElement />}
    </div>
  );
};
